import React, { useState, Fragment, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Drawer, Table, Popconfirm,
} from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';

import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import closeIcon from '@Images/icons/icon-close-blue.png';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import CMActions from '@Actions/settings/cmActions';
import './style.scss';
import FormCustomReasons from './FormCustomReasons';

/**
 *
 */
const CustomReasons = ({
  getCM, user, deleteCMLoading, type, deleteCM, getcustomMessageStockAdjustmentLoading, customMessageStockAdjustment,  getcustomMessageBillOfMaterialLoading, customMessageBillOfMaterial 
}) => {
  const [showCreateCM, setShowCreateCM] = useState(false);
  const [showUpdateCM, setShowUpdateCM] = useState(false);
  const [selectedCM, setSelectedCM] = useState(null);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [text, setText] = useState('');

  useEffect(() => {
    getCM(user?.tenant_info?.org_id, '', type);
    handleTextUpdate(type);
  }, []);

  const columns = [
    {
      title: `${text.toUpperCase()} NAME`,
      render: (record) => <div>{record?.message?.replace(/_/g, ' ')?.toProperCase()}</div>,
      hidden: false,
    },
    {
      title: 'TYPE',
      render: (record) => (
        <div>
          <H3Text text={record?.type} className="" />
        </div>
      ),
      hidden: (type==="STOCK ADJUSTMENT" ? false : true),
    },
    {
      title: 'Actions',
      render: (record) => (
        <div style={{
          textAlign: 'center', display: 'flex', alignItems: 'center',
        }}
        >
          <div
            className="roundIconButton"
            onClick={() => {
              setSelectedCM(record);
              setShowUpdateCM(true);
            }}
          >
            <EditOutlined />
          </div>
          <Popconfirm
            placement="topRight"
            title="Are you sure you want to delete this reason?"
            onConfirm={() => deleteCM({ entity_level_message_id: record?.entity_level_message_id },
              () => getCM(user?.tenant_info?.org_id, '', type))}
            okText="Yes"
            cancelText="No"
          >
            <div
              className="deleteButton"
            >
              <DeleteOutlined />
            </div>
          </Popconfirm>
        </div>
      ),
      hidden: false,
    },
  ].filter(item => item.hidden === false);
  
  const handleTextUpdate = (type) => {
    if (type === "STOCK ADJUSTMENT") {
        setText("Reason");
    } else if (type === "BILL_OF_MATERIAL") {
        setText("Charge");
    } else {
        setText("Reason");
    }
};

  function getCMTypeData(entityTypes) {
    switch (entityTypes) {
    // case 'PRODUCTS':
    //   return customMessageProducts;
    // case 'VENDORS':
    //   return customMessageVendors;
    // case 'DELIVERY_CHALLAN':
    //   return customMessageDeliveryChallan;
    case 'STOCK ADJUSTMENT':
      return customMessageStockAdjustment;
     case 'BILL_OF_MATERIAL':
       return customMessageBillOfMaterial;
    // case 'STOCK_TRANSFER':
    //   return customMessageStockTransfer;
    // case 'CUSTOMER_PAYMENT':
    //   return customMessageCustomerPayment;
    // case 'VENDOR_PAYOUT':
    //   return customMessageVendorPayout;
    // case 'SALES_ORDER':
    //   return customMessageSalesOrder;
    // case 'MANUFACTURING_ORDER':
    //   return customMessageManufacturingOrder;
    // case 'DEBIT_NOTE':
    //   return customMessageDebitNote;
    // case 'GOOD_RECEIVING_NOTES':
    //   return customMessageGoodReceivingNotes;
    // case 'PURCHASE_ORDERS':
    //   return customMessagePurchaseOrders;
    // case 'PURCHASE_REQUEST':
    //   return customMessagePurchaseRequest;
    // case 'CREDIT_NOTE':
    //   return customMessageCreditNote;
    // case 'CUSTOMERS':
    //   return customMessageCustomers;
    // case 'INVOICE':
    //   return customMessageInvoice;
    default:
      return {};
    }
  }

  function getCMTypeLoading(entityTypes) {
    switch (entityTypes) {
    // case 'PRODUCTS':
    //   return getcustomMessageProductsLoading;
    // case 'VENDORS':
    //   return getcustomMessageVendorsLoading;
    // case 'DELIVERY_CHALLAN':
    //   return getcustomMessageDeliveryChallanLoading;
    case 'STOCK ADJUSTMENT':
      return getcustomMessageStockAdjustmentLoading;
    case 'BILL_OF_MATERIAL':
       return getcustomMessageBillOfMaterialLoading;
      // case 'STOCK_TRANSFER':
      //   return getcustomMessageStockTransferLoading;
      // case 'CUSTOMER_PAYMENT':
      //   return getcustomFieldcustomerPaymentLoading;
      // case 'VENDOR_PAYOUT':
      //   return getcustomMessageVendorPayoutLoading;
      // case 'SALES_ORDER':
      //   return getcustomMessageSalesOrderLoading;
      // case 'MANUFACTURING_ORDER':
      //   return getcustomMessageManufacturingOrderLoading;
      // case 'DEBIT_NOTE':
      //   return getcustomMessageDebitNoteLoading;
      // case 'GOOD_RECEIVING_NOTES':
      //   return getcustomMessageGoodReceivingNotesLoading;
      // case 'PURCHASE_ORDERS':
      //   return getcustomMessagePurchaseOrdersLoading;
      // case 'PURCHASE_REQUEST':
      //   return getcustomMessagePurchaseRequestLoading;
      // case 'CREDIT_NOTE':
      //   return getcustomMessageCreditNoteLoading;
      // case 'CUSTOMERS':
      //   return getcustomMessagecustomersLoading;
      // case 'INVOICE':
      //   return getcustomMessageInvoiceLoading;
    default:
      return false;
    }
  }
  return (
    <Fragment>
      <Drawer
        open={showCreateCM}
        width="360px"
        mask
        onClose={() => setShowCreateCM(false)}
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '315px' }}>
            <H3Text text={`Add New ${text}`} className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowCreateCM(false)} />
          </div>
        </div>
        <div className="create-po__new-vendor-wrapper">
          <FormCustomReasons
            entity={type}
            callback={() => {
              setShowCreateCM(false);
              getCM(user?.tenant_info?.org_id, '', type, page, limit);
            }}
          />
        </div>
      </Drawer>
      <Drawer
        open={showUpdateCM}
        width="360px"
        mask
        onClose={() => setShowUpdateCM(false)}
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '315px' }}>
            <H3Text text={`Update Custom ${text}`} className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowUpdateCM(false)} />
          </div>
        </div>
        <div className="create-po__new-vendor-wrapper">
          <FormCustomReasons
            callback={() => {
              setShowUpdateCM(false);
              getCM(user?.tenant_info?.org_id, '', type, page, limit);
            }}
            entity={type}
            selectedCM={selectedCM}
          />
        </div>
      </Drawer>
      <div className="ant-row">
        <div className="ant-col-md-24">
          <div className="generic-table-container" style={{ margin: '0px !important' }}>
            <Table
              title={() => (
                <div style={{ display: 'flex', justifyContent: 'space-between', 'align-items': 'baseline' }}>
                  {`${getCMTypeData(type)?.data?.length || 0} Custom ${text}`}
                  <H3Button
                    buttonType={defaultButtonTypes.BLUE_ROUNDED}
                    text={`+ New ${text}`}
                    onClick={() => setShowCreateCM(true)}
                    customClass="cr__header__add-button hide__in-mobile"
                  />
                </div>
              )}
              columns={columns}
              size="small"
              scroll="scroll"
              loading={getCMTypeLoading(type) || deleteCMLoading}
              dataSource={getCMTypeData(type)?.data || []}
              pagination={getCMTypeData(type)?.data?.length > 10 ? {
                current: page,
                total: getCMTypeData(type)?.data?.length ? getCMTypeData(type)?.data?.length : 0,
                pageSize: limit,
                position: ['bottomRight'],
                showSizeChanger: false,
                onChange: (pg, size) => {
                  getCM(user?.tenant_info?.org_id, '', type, pg, size);
                  setLimit(size);
                  setPage(pg);
                },
              } : false}
            />
          </div>
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = ({ UserReducers, CMReducers }) => ({
  user: UserReducers.user,
  customMessageStockAdjustment: CMReducers.customMessageStockAdjustment,
  customMessageBillOfMaterial: CMReducers.customMessageBillOfMaterial,
  getcustomMessageStockAdjustmentLoading: CMReducers.getcustomMessageStockAdjustmentLoading,
  getcustomMessageBillOfMaterialLoading: CMReducers.getcustomMessageBillOfMaterialLoading,
  getCMLoading: CMReducers.getCMLoading,
  deleteCMLoading: CMReducers.deleteCMLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getCM: (orgId, entityId, entityType, page, limit) => dispatch(CMActions.getCM(orgId, entityId, entityType, page, limit)),
  deleteCM: (payload, callback) => dispatch(CMActions.deleteCM(payload, callback)),
});

CustomReasons.propTypes = {
  getCMLoading: PropTypes.bool,
  customMessageStockAdjustment: PropTypes.any,
  customMessageBillOfMaterial: PropTypes.any,
  getcustomMessageStockAdjustmentLoading: PropTypes.bool,
  getcustomMessageBillOfMaterialLoading: PropTypes.bool,
  user: PropTypes.any,
  getCM: PropTypes.func,
  deleteCM: PropTypes.func,
  deleteCMLoading: PropTypes.bool,
  type: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CustomReasons));
